<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card
      v-card-title {{ editId ? 'Изменить папку' : 'Создать папку' }}
        v-spacer
        v-btn(@click="close" icon)
          v-icon mdi-close
      v-card-text
        v-text-field(
          v-model="newFolderName"
          label="Название папки"
          @keyup.enter="onKeyupEnter"
          rounded filled
        )
      v-card-actions.pb-4.pr-4
        v-spacer
        v-btn(v-if="!editId" @click="createFolder" :loading="loading" color="success" text) Создать
        v-btn(v-if="editId" @click="editFolder" :loading="loading" color="success" text) Изменить
        v-btn(@click="close" color="success" text) Отмена
</template>

<script>
export default {
  name: 'CreateTaskFolderDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editFolderData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      editId: null,
      newFolderName: '',
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val && this.editFolderData) {
        this.newFolderName = this.editFolderData.name;
        this.editId = this.editFolderData.id;
      }
      if (val && !this.editFolderData) {
        this.newFolderName = '';
        this.editId = null;
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.newFolderName = '';
    },
    onKeyupEnter() {
      if (this.editId) {
        this.editFolder();
      } else {
        this.createFolder();
      }
    },
    createFolder() {
      this.loading = true;

      const data = {
        name: this.newFolderName,
        model: {
          name: 'task',
          ids: [],
        },
      };
      this.$rHandler(
        this.$api.categories.createCategory(data),
        (r) => {
          this.loading = false;
          this.$emit('on-folder-create', {
            id: r.data.data,
            name: this.newFolderName,
            showDelete: false,
          });
          this.close();
        },
        () => {
          this.loading = false;
        },
      );
    },
    editFolder() {
      this.loading = true;
      this.$rHandler(
        this.$api.categories.updateCategory(this.editId, { name: this.newFolderName }),
        () => {
          this.loading = false;
          this.$emit('on-folder-edit', {
            id: this.editId,
            name: this.newFolderName,
            showDelete: false,
          });
          this.close();
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style scoped>

</style>
